import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-tongue-wink': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M152 180C126.3 180 96.1 196.9 92.2 222.1 91.4 227.1 93.9 232.1 98.3 234.5 102.7 236.9 108.2 236.3 112 232.9L121.5 224.4C136.3 211.2 167.7 211.2 182.5 224.4L192 232.9C194.5 235.1 200 237.6 205.7 234.5 210.1 232.1 212.6 227.1 211.8 222.1 207.9 196.9 177.7 180 152 180zM328 128C283.8 128 248 163.8 248 208S283.8 288 328 288 408 252.2 408 208 372.2 128 328 128zM328 256C301.5 256 280 234.5 280 208S301.5 160 328 160 376 181.5 376 208 354.5 256 328 256zM328 184C314.7 184 304 194.7 304 208S314.7 232 328 232 352 221.3 352 208 341.3 184 328 184zM248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM312 408C312 443.6 282.9 472.5 247.1 472 212 471.5 184 442.2 184 407V364.2L201.7 355.4C216.7 347.9 233.2 357.1 236.6 371.9L239.4 384C241.5 393.2 254.6 393.2 256.7 384L259.5 371.9C262.9 357.1 279.3 347.8 294.4 355.4L312.1 364.2V408zM340.2 433.3C342.4 425.2 344 416.8 344 408V364.5C358.2 352.1 368.4 337 371.3 320 373 310.1 363.6 301.5 353.6 304.7 327.7 313 289.2 317.8 248 317.8S168.4 313 142.4 304.7C132.5 301.6 123 310 124.7 320 127.6 337 137.8 352.1 152 364.5V408C152 416.8 153.6 425.2 155.8 433.3 91.8 399.9 48 333 48 256 48 145.7 137.7 56 248 56S448 145.7 448 256C448 333 404.2 399.9 340.2 433.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-tongue-wink.js
// module id = iqd3
// module chunks = 144